import { createSelector } from '@reduxjs/toolkit'
import { sortCheckpointableEntities } from '../../../helpers/sortCheckpointableEntities'
import {
  getTodoPhaseItemsIds,
  getTodoAssignmentsIds,
} from '../../getters/entities/taskIds'
import { NormalizedTask } from '../types'
import { selectNormalizedTasks } from './normalizedTasks'

const selectTodoAssignmentIds = createSelector(
  [getTodoAssignmentsIds],
  (todoAssignmentIds) => todoAssignmentIds || []
)

const selectTodoPhaseItemIds = createSelector(
  [getTodoPhaseItemsIds],
  (todoPhaseItemIds) => todoPhaseItemIds || []
)

export const selectTodoTasks = createSelector(
  [selectNormalizedTasks, selectTodoAssignmentIds, selectTodoPhaseItemIds],
  (normalizedTasks, todoAssignmentIds, todoPhaseItemIds) => {
    const phaseItems = todoPhaseItemIds.map((id) =>
      normalizedTasks.find(
        (task) => task.id === id && task.entityType === 'phase_item'
      )
    )

    const assignments = todoAssignmentIds.map((id) =>
      normalizedTasks.find(
        (approval) => approval.id === id && approval.entityType === 'assignment'
      )
    )

    return sortCheckpointableEntities(
      [...phaseItems, ...assignments].filter(
        (task): task is NormalizedTask => task !== undefined
      )
    )
  }
)
